import { render, staticRenderFns } from "./administratorForm.vue?vue&type=template&id=6ade2d68&scoped=true&"
import script from "./administratorForm.vue?vue&type=script&lang=js&"
export * from "./administratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade2d68",
  null
  
)

export default component.exports